import { useCallback, useMemo } from 'react';
import { UserSetting } from 'src/WebApiController';

import { useServerUserSetting } from './useUserSetting';

export const useFavoriteVendorIds = () => {
  const { value: _favoriteVendorIds, setUserSetting: _setFavoriteVendorIds } =
    useServerUserSetting<number[]>({
      id: UserSetting.FavoriteVendorIds,
    });

  const favoriteVendorIds = useMemo(
    () => _favoriteVendorIds ?? [],
    [_favoriteVendorIds]
  );

  const setFavoriteVendorId = useCallback(
    (id: number, isFavorite: boolean) => {
      if (isFavorite) {
        _setFavoriteVendorIds(
          favoriteVendorIds.filter((favId) => favId !== id)
        );
      } else {
        _setFavoriteVendorIds([...favoriteVendorIds, id]);
      }
    },
    [favoriteVendorIds, _setFavoriteVendorIds]
  );

  return {
    favoriteVendorIds,
    setFavoriteVendorId,
  };
};
